import { ChangeDetectionStrategy, Component, input, viewChild } from '@angular/core';
import { TooltipDirective } from '@catch/directives';
import { ButtonComponent } from '@catch/general-ui';
import { TranslocoPipe } from '@jsverse/transloco';
import { PlatformFollowUpChoiceModalComponent } from '../follow-up-choice-modal/platform-follow-up-choice-modal.component';
import { PlatformApplyWithProfileContext } from '../../services/platform-jobs.service';

@Component({
  selector: 'app-platform-job-apply-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    TranslocoPipe,
    TooltipDirective,
    PlatformFollowUpChoiceModalComponent,
  ],
  template: `
    @if (applied()) {
      <span
        class="apply-button-wrap"
        [tooltip]="'jobboard.platform.apply-menu.tooltip-applied' | transloco"
      >
        <app-button variant="white-grey" [disabled]="true">
          {{ 'jobboard.platform.jobs.apply-label' | transloco }}
        </app-button>
      </span>
    } @else {
      <app-button variant="white-grey" (click)="openChoice()">
        {{ 'jobboard.platform.jobs.apply-label' | transloco }}
      </app-button>
    }
    <app-platform-follow-up-choice-modal #choiceModal />
  `,
  styles: `
    :host {
      display: inline-flex;
      align-items: center;
      vertical-align: middle;
      line-height: normal;
    }

    .apply-button-wrap {
      display: inline-flex;
      align-items: center;
      vertical-align: middle;
    }

    :host ::ng-deep button.ct-btn {
      line-height: 1.5;
    }
  `,
})
export class PlatformJobApplyMenuComponent {
  readonly context = input.required<PlatformApplyWithProfileContext>();
  readonly applied = input(false);

  private readonly choiceModal =
    viewChild.required<PlatformFollowUpChoiceModalComponent>('choiceModal');

  /**
   * Opens the profile-or-manual apply choice modal.
   */
  openChoice(): void {
    if (this.applied()) {
      return;
    }
    this.choiceModal().openApply(this.context());
  }
}
